import {toAbsoluteUrl} from '_metronic/helpers'
import {FC} from 'react'
import {Link} from 'react-router-dom'

type Props = {
  icon?: string
  title?: string
  desc?: string
  tabs?: Array<{slug: string; title: string; href: string; badgeValue?: string}>
  activeTab?: string
  sideButtonGroup?: React.ReactNode
}

const Layout: FC<Props> = ({icon, title, desc, tabs, activeTab, sideButtonGroup}) => {
  return (
    <div className={`card mb-5 mb-xl-8`}>
      <div className='card-header border-0 pt-5 mb-5'>
        <div className='d-flex align-items-center'>
          <div className='symbol symbol-45px me-5'>
            <img src={toAbsoluteUrl(`/media/logos/${icon}`)} alt={`${title}-icon`} />
          </div>
          {/* <div
            className='d-flex align-items-center justify-content-center border border-gray-300 rounded-circle  me-5'
            style={{width: '45px', height: '45px'}}
          >
            <KTIcon iconName={`${icon}`} className='fs-2 text-primary' />
          </div> */}

          <div className='d-flex justify-content-start flex-column'>
            <span className='card-label fw-bold fs-5'>{title}</span>
            <span className='fs-6 text-secondary-gray'>{desc}</span>
          </div>
        </div>

        {sideButtonGroup && (
          <div className='ms-auto d-flex' style={{gap: '12px'}}>
            {sideButtonGroup}
          </div>
        )}
      </div>

      {tabs && tabs.length > 0 && (
        <div className='px-10 '>
          <div className='d-flex h-55px border-bottom'>
            <ul className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-semibold flex-nowrap '>
              {tabs.map((tab) => (
                <li key={tab.slug} className='nav-item'>
                  <Link
                    to={tab.href}
                    style={{
                      color: '#6a7282',
                    }}
                    className={`nav-link fw-bold me-6 text-active-primary ${
                      activeTab === tab.slug ? 'active' : ''
                    }`}
                  >
                    {tab.title}

                    {tab.badgeValue && (
                      <div
                        className='d-flex justify-content-center align-items-center'
                        style={{
                          background: '#E5E7EB',
                          borderRadius: '9999px',
                          width: '20px',
                          height: '20px',
                          marginInlineStart: '6px',
                        }}
                      >
                        <span className='fw-medium' style={{color: '#1F2A37', fontSize: '12px'}}>
                          {tab.badgeValue}
                        </span>
                      </div>
                    )}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      )}
    </div>
  )
}

export default Layout
